export const projectHomeRoutes = {
  home: "",
} as const;

export type ProjectHomeRouteParams = {
  home: {
    startDate?: string;
  };
};
